import Vue from 'vue';

export default {
  // 发票列表
  getAssetsList(params) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/selectListByPage', params);
  },
  // 获取开票信息
  getAssetsInfo(bidId) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/selectInfoById', bidId);
  },
  sendInfo(params) {
    return Vue.axios.post('/api/v1.0/chanquan/invoice/applyInvoice', params);
  },
  getDetail(projectId, bidId, projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/invoice/invoiceDetails/' + projectId + '/' + bidId + '/' + projectType);
  },
  // 添加资产
  assetsSave(params) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/save', params);
  }
};
